/**
 * House Decision Graph
 *
 * Complete graph definition for the house decision analysis.
 * Compares keeping property as rental vs selling and investing.
 */

import { GraphDefinition, Node } from '../../lib/computation-graph';
import { sources } from './sources';
import { assumptions } from './assumptions';
import { computedNodes } from './computed';

// Combine all nodes
const allNodes: Record<string, Node> = {
  ...sources,
  ...assumptions,
  ...computedNodes,
};

/**
 * The complete house decision graph definition
 */
export const houseDecisionGraph: GraphDefinition = {
  id: 'house-decision',
  name: 'House Decision Analysis',
  description: 'Compare keeping inherited property as rental vs selling and investing in stocks',
  nodes: allNodes,
};

// Re-export individual modules for direct access
export { sources } from './sources';
export { assumptions } from './assumptions';
export { computedNodes } from './computed';

export default houseDecisionGraph;
